import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  standalone: true,
  selector: "app-prefix-pa3",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-pa3.component.html",
  styleUrl: "./prefix-pa3.component.less",
})
export class PrefixPa3Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 36;
    this.characters = ALLOWED_CHARACTERS["pa3"];
  }
}
